import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {
  IAirportInitialState,
  ISetAirportListPayload
} from "./airportReducerTypes";

const airportInitialState: IAirportInitialState = {
  airports: [],
  isLoading: false,
  errorMessage: '',
};

const airportSlice = createSlice({
  name: 'airport',
  initialState: airportInitialState,
  reducers: {
    getAirportList(state) {
      state.isLoading = true;
      state.errorMessage = '';
    },
    setAirportList(state, {payload}: PayloadAction<ISetAirportListPayload>) {
      state.airports = payload.airports;
      state.isLoading = false;
      state.errorMessage = '';
    },
    setAirportListError(state, {payload}: PayloadAction<{errorMessage: string}>) {
      state.isLoading = false;
      state.errorMessage = payload.errorMessage;
    },
  },
});

export const {
  getAirportList,
  setAirportList,
  setAirportListError,
} = airportSlice.actions;

export default airportSlice.reducer;
